import * as React from "react";
import { PlaceholderBtn } from "./PlaceholderBtn";
import { PlaceholderInfo } from "./PlaceholderInfo";
export class Placeholder extends React.PureComponent {
    renderItems(eventsCount) {
        let elements = [];
        for (let i = 1; i <= eventsCount; i++) {
            elements.push(React.createElement("div", { key: `placeholder_item_${i}`, className: "rj-ev-list__placeholder__card-items-wrap" },
                React.createElement(PlaceholderInfo, null),
                React.createElement(PlaceholderBtn, null)));
        }
        return elements;
    }
    render() {
        return (React.createElement("div", { className: "rj-ev-list__placeholder" },
            React.createElement("div", { className: "rj-ev-list__placeholder__header" },
                React.createElement("div", { className: "rj-ev-list__placeholder__header-text" })),
            this.renderItems(this.props.eventsCount)));
    }
}
//# sourceMappingURL=Placeholder.js.map